import ElementContentSearchPage from '@/components/sections/builder/elements/body/search/content';
import { SearchPageElementDataType } from '@/components/sections/builder/elements/body/search/type';
import { BetweenHorizontalStart } from 'lucide-react';
import ElementSetting from '@/components/sections/builder/elements/body/search/setting';

export const defaultDataSearchPage: SearchPageElementDataType = {
  name: 'Search Page',
  headingLabel: 'Featured products',
  headingSize: 'small',
  textLabel: '',
  textStyle: 'body',
  limit: 4,
  totalCol: 4,
  totalColMobile: 1,
  size: 'small',
  showImage: true,
  showCategory: true,
  showShadow: false,
  rounded: 0,
  imageRatio: 'square',
  viewAllStyle: 'default',
  enableQuickAddButton: true,
  enableFilter: true,
  enableSort: true,
  filterLayout: 'vertical',
  showFilterAvailability: true,
  showFilterPrice: true,
  showTotalProduct: true,
};

export const ElementPreviewIcon = BetweenHorizontalStart;

const SearchPage = {
  type: 'search',
  group: 'body_search',
  defaultData: defaultDataSearchPage,
  Element: ElementContentSearchPage,
  PreviewIcon: ElementPreviewIcon,
  Setting: ElementSetting,
  defaultChilds: [],
  childs: [],
  isImmutable: true,
  maxEntries: 1,
};

export default SearchPage;
